export const state = () => ({
  loading: false,
  contactForm: null,
  thankYou: null
})
export const getters = {
  loading(state) {
    return state.loading
  },
  contactForm(state) {
    return state.contactForm
  },
  thankYou(state) {
    return state.thankYou
  }
}
export const mutations = {
  setLoading(state, newState) {
    state.loading = newState
  },
  setContactForm(state, { data }) {
    state.contactForm = data
  },
  setThankYou(state, { data }) {
    state.thankYou = data
  }
}
export const actions = {
  sendContactFormOMR(
    { commit, rootState },
    { name, email, company, message, legals }
  ) {
    commit('setLoading', true)
    return this.$axios
      .post(`${window.location.origin}/api/contact/omr`, {
        name,
        email,
        company,
        message,
        language: rootState.language,
        legals
      })
      .then(() => {
        commit('setLoading', false)
      })
      .catch((err) => {
        commit('setLoading', false)
        console.error(err)
      })
  },
  sendContactForm(
    { commit, rootState },
    { name, email, company, message, legals }
  ) {
    commit('setLoading', true)
    return this.$axios
      .post(`${window.location.origin}/api/contact`, {
        name,
        email,
        company,
        message,
        language: rootState.language,
        legals
      })
      .then(() => {
        commit('setLoading', false)
      })
      .catch((err) => {
        commit('setLoading', false)
        console.error(err)
      })
  },
  sendTechnologyForm(
    { commit, rootState },
    { name, email, company, message, products, services, legals }
  ) {
    commit('setLoading', true)
    return this.$axios
      .post(`${window.location.origin}/api/contact/technology`, {
        name,
        email,
        company,
        message,
        language: rootState.language,
        products,
        services,
        legals
      })
      .then(() => {
        commit('setLoading', false)
      })
      .catch((err) => {
        commit('setLoading', false)
        console.error(err)
      })
  },
  getContactForm({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/contact_form.json`)
      .then((res) => {
        commit('setContactForm', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getThankYou({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/contact_thank_you.json`)
      .then((res) => {
        commit('setThankYou', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  }
}
